export enum TaskLabel {
  GOVERNANCE_T1 = "GOVERNANCE_T1",
  GOVERNANCE_T2 = "GOVERNANCE_T2",
  GOVERNANCE_T3 = "GOVERNANCE_T3",
  COMMON_ACTIVITIES = "COMMON_ACTIVITIES",
  PROJECT_MANAGEMENT = "PROJECT_MANAGEMENT",
  LAND = "LAND",
  PERMIT = "PERMIT",
  GRID = "GRID",
  YIELD = "YIELD",
  CONTRACTS = "CONTRACTS",
  PROJECT_ECONOMICS = "PROJECT_ECONOMICS",
}

export const taskLabelToLabel = {
  [TaskLabel.GOVERNANCE_T1]: 'Governance - Tier 1',
  [TaskLabel.GOVERNANCE_T2]: 'Governance - Tier 2',
  [TaskLabel.GOVERNANCE_T3]: 'Governance - Tier 3',
  [TaskLabel.COMMON_ACTIVITIES]: 'Common Activities',
  [TaskLabel.PROJECT_MANAGEMENT]: 'Project Management',
  [TaskLabel.LAND]: 'Land',
  [TaskLabel.PERMIT]: 'Permit',
  [TaskLabel.GRID]: 'Grid',
  [TaskLabel.YIELD]: 'Energy Yield',
  [TaskLabel.CONTRACTS]: 'Contracts',
  [TaskLabel.PROJECT_ECONOMICS]: 'Project Economics',
};
